import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { FooterComponent } from '../layout/footer/footer.component';
import { AuthService } from '../../core/services/auth.service';
import { TranslationService } from '../../core/services/translation.service';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';
import { extractHttpErrorMessage } from '../../core/utils/http-error.util';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, FooterComponent, TranslatePipe],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  protected showPassword = false;
  protected isSubmitting = false;
  protected errorMessage = '';
  protected readonly form;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly authService: AuthService,
    private readonly translationService: TranslationService,
    private readonly router: Router
  ) {
    this.form = this.formBuilder.nonNullable.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      remember: [false]
    });
  }

  protected togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  protected submit(): void {
    if (this.form.invalid || this.isSubmitting) {
      this.form.markAllAsTouched();
      return;
    }

    const { username, password, remember } = this.form.getRawValue();

    this.isSubmitting = true;
    this.errorMessage = '';

    this.authService.login({
      username: username.trim(),
      password
    }, remember).subscribe({
      next: (session) => {
        this.isSubmitting = false;
        void this.router.navigateByUrl(session.role?.toUpperCase() === 'ADMIN' ? '/admin' : '/localization');
      },
      error: (error: unknown) => {
        this.errorMessage = this.extractErrorMessage(error);
        this.isSubmitting = false;
      }
    });
  }

  protected hasError(controlName: 'username' | 'password'): boolean {
    const control = this.form.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  private extractErrorMessage(error: unknown): string {
    return extractHttpErrorMessage(error, this.translationService.translate('login.errorFallback'));
  }
}
